






































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { BooleanProp, OptionalProp } from '@pjn/vue-core/component';
import UserComponent from '../user/UserComponent.vue';
import { User } from '@pjn/core/model/app/User';
import MenuItem from '@pjn/core/model/app/MenuItem';
import ToolbarInlineMenu from './ToolbarInlineMenu.vue';
import ToolbarExtendedMenu from './ToolbarExtendedMenu.vue';
import ToolbarUser from './ToolbarUser.vue';

/** 
 * Toolbar.
 * Se adapta a desktop y mobile y soporta items de menu y manejo del usuario.
 * 
 * Implementa slots y portales para que la aplicacion pueda modificar los items o el titulo.
 */
@Component({ components: { UserComponent, ToolbarInlineMenu, ToolbarExtendedMenu, ToolbarUser } })
export default class Toolbar extends Vue {

  /** Color de la toolbar */
  @Prop({ default: 'light-blue darken-3' }) color: string;

  /** Prefijo del titulo en Desktop */
  @Prop({ default: 'Poder Judicial de la Nación' }) preTitle: string;

  /** Prefijo del titulo en Mobile */
  @Prop({ default: 'PJN' }) preTitleMobile: string;

  /** Titulo */
  @Prop() title: string;

  /** Comprime la altura (default true) */
  @BooleanProp(true) dense: boolean;

  /** Extiende la toolbar a dos lineas */
  @BooleanProp(false) extended: boolean;

  /** Altura de la extension */
  @OptionalProp({type: [Number, String]}) extensionHeight: number | string;

  /** Remueve la sombra */
  @BooleanProp(false) flat: boolean;

  /** Items del menu */
  @Prop({ type: Array, default: () => [] })
  items: MenuItem[];

  /** Item seleccionado del menu */
  @OptionalProp() selected: MenuItem | null;

  /** Info del usuario a mostrar (o null si no hay usuario) */
  @OptionalProp() user: User | null;

  /** [Mobile] Indica si se muestra el boton de Back en lugar del menu lateral */
  @BooleanProp(false) showBack: boolean;

  scrolled: boolean = false;

  get isDense() {
    // return this.$mobile || this.dense;
    return this.dense;
  }

  get isExtended() {
    return (
      !this.isMobile &&
      this.extended &&
      !this.scrolled &&
      this.items &&
      this.items.length > 0
    );
  }

  get isMobile() {
    return (this as any).$vuetify.breakpoint.xsOnly;
  }

  onItemClick(item: MenuItem) {
    this.$emit('itemClick', item);
  }

  onScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop;
    this.scrolled = offset > 0;
  }

  get upperCaseTitle() {
    return this.title ? this.title.toUpperCase() : '';
  }
}
